import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 20 20">
      <path d="M9.99997 4.10746L7.64294 6.46448L8.82145 7.64299L11.1785 5.28597C12.1507 4.3137 13.7417 4.3137 14.714 5.28597C15.6863 6.25824 15.6863 7.84923 14.714 8.8215L12.357 11.1785L13.5355 12.357L15.8925 10C17.5189 8.37367 17.5189 5.7338 15.8925 4.10746C14.2662 2.48111 11.6263 2.48111 9.99997 4.10746ZM11.1785 12.357L8.82145 14.7141C7.84918 15.6863 6.25819 15.6863 5.28592 14.7141C4.31365 13.7418 4.31365 12.1508 5.28592 11.1785L7.64294 8.8215L6.46443 7.64299L4.10741 10C2.48107 11.6264 2.48107 14.2662 4.10741 15.8926C5.73376 17.5189 8.37362 17.5189 9.99997 15.8926L12.357 13.5355L11.1785 12.357ZM7.05369 11.7678L11.7677 7.05373L12.9462 8.23224L8.2322 12.9463L7.05369 11.7678Z"/>
    </CommonSVGIcon>
  );
}
